import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import rightArrowIcon from "../../assets/images/white-right-arrow-btn.svg";
import { useLocation } from "react-router-dom";
import { HandleConsent } from "../../services/api/stream";
import toastify from "shared/toastr";

const ConsentPage = (props) => {
  const [show, setShow] = useState(true);
  const [params, setParams] = useState(null);
  const location = useLocation();
  const clientId = new URLSearchParams(location.search).get("clientId");
  const redirectUri = new URLSearchParams(location.search).get("redirectUri");
  const userId = new URLSearchParams(location.search).get("userId");
  const [isLoading, setisLoading] = useState(false);

  useEffect(() => {
    if (clientId && redirectUri && userId) {
      setParams({ clientId, redirectUri, userId });
    }
  }, []);

  const submitConsent = async () => {
    if (params) {
      const authUrl = `clientId=${clientId}&redirectUri=${encodeURIComponent(
        redirectUri
      )}&userId=${userId}&approved=${true}`;
      const url = `https://api.backhouse.io/api/v1/StreamOrders/confirm?${authUrl}`;
      window.location.replace(url);
      toastify("success", "Success");
    }
  };

  const handleClose = async () => {
     setShow(false);
     props.history.push("/dashboard");
 };

  return (
    <div className="confirmation__wrapper">
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        id="confirmation__modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="confirmation__heading">Consent Request</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <p className="mb-0">
            <p>
              <strong>Stream Orders is requesting permission to:</strong>
            </p>
            <ul>
              <li>View and manage your restaurant information</li>
              <li>View and manage your menus</li>
              <li>View and manage your orders</li>
            </ul>
            <p>Do you want to approve this access?</p>
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            onClick={handleClose}
            className="cancel-btn red-btn-ghost btn"
          >
            Deny
          </Button>
          <Button
            onClick={submitConsent}
            disabled={isLoading}
            className="red-btn btn"
          >
            Approve
            <span className="icons-right">
              <img src={rightArrowIcon} alt="arrow icon" />
            </span>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConsentPage;
